import React from 'react';
import PropTypes from 'prop-types';

import UploadArea from '@components/common/filestack_uploader/upload_area';
import VersionUppy from '@components/common/uppy/version_uppy';
import download from '@helpers/download';

const SubmitButton = ({
  activeAttachment,
  asset,
  checkedInStatus,
  handleToggleCheckinCheckout,
  setVersionsActionLoading,
  versionCard,
  versionsActionLoading,
}) => {
  const handleSubmitCheckout = () => {
    const { url, filename, metadata } = versionCard.version_details;
    download(url, { filename, filetype: metadata.mime_type });
    handleToggleCheckinCheckout();
  };

  const uploadOptions = {
    maxFiles: 1,
    onFileUploadStarted: () => setVersionsActionLoading(true),
  };

  if (checkedInStatus === 'checked_in') {
    return (
      <div className="checkin-checkout__button-container">
        <button
          className="button primary lg"
          disabled={versionsActionLoading}
          onClick={handleSubmitCheckout}
          type="button"
        >
          {t('Check Out & Download')}
        </button>
      </div>
    );
  }

  if (checkedInStatus === 'checked_out' && !BFG.hasFeature('uppy_uploader_features') && !versionsActionLoading) {
    return (
      <UploadArea
        asset={asset}
        assetKey={asset.id}
        attachment={activeAttachment}
        handleToggleCheckinCheckout={handleToggleCheckinCheckout}
        options={uploadOptions}
        type="button"
        uniqDomElement={`version-status-uploader-checkin-${activeAttachment.id}`}
        uploadType="attachment-version-status"
      />
    );
  }

  if (checkedInStatus === 'checked_out' && BFG.hasFeature('uppy_uploader_features') && !versionsActionLoading) {
    return (
      <div className="checkin-checkout__button-container">
        <VersionUppy
          attachmentKey={activeAttachment.id}
          assetKey={asset.id}
          handleToggleCheckinCheckout={handleToggleCheckinCheckout}
        />
      </div>
    );
  }

  return null;
};

SubmitButton.propTypes = {
  activeAttachment: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  asset: PropTypes.shape({
    asset_key: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  checkedInStatus: PropTypes.oneOf(['checked_in', 'checked_out']).isRequired,
  handleToggleCheckinCheckout: PropTypes.func.isRequired,
  setVersionsActionLoading: PropTypes.func.isRequired,
  versionCard: PropTypes.shape({
    version_details: PropTypes.shape({
      url: PropTypes.string,
      filename: PropTypes.string,
      metadata: PropTypes.shape({
        mime_type: PropTypes.string,
      }),
    })
  }).isRequired,
  versionsActionLoading: PropTypes.bool.isRequired,
};

export default SubmitButton;
